import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RevokeReservationDialogData {
  shouldAskForSlotClosing: boolean;
  reservationId: string;
  isDwspayPayment?: boolean;
  isPaid?: boolean;
  paymentRefunded?: boolean;
  paidAmount?: number;
  currencySymbol?: string;
}

export interface RevokeReservationDialogResult {
  confirmed: boolean;
  shouldRefund: boolean;
}

@Component({
  selector: 'app-revoke-reservation-dialog',
  templateUrl: './revoke-reservation-dialog.component.html',
  styleUrls: ['./revoke-reservation-dialog.component.scss']
})
export class RevokeReservationDialogComponent {
  shouldRefund = false;
  isProcessing = false;
  
  constructor(
    public dialogRef: MatDialogRef<RevokeReservationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RevokeReservationDialogData
  ) {}

  get showRefundSection(): boolean {
    return !!(this.data.isDwspayPayment && this.data.isPaid && !this.data.paymentRefunded);
  }

  get refundAmount(): string {
    const symbol = this.data.currencySymbol || '\u20ac';
    const amount = this.data.paidAmount || 0;
    return `${symbol}${amount.toFixed(2)}`;
  }

  get refundDescription(): string {
    return `revoke_dialog.refund_description`;
  }

  get processingMessage(): string {
    if (this.shouldRefund) {
      return 'revoke_dialog.processing_with_refund';
    }
    return 'revoke_dialog.processing';
  }

  onCancel(): void {
    if (this.isProcessing) return;
    this.dialogRef.close({ confirmed: false, shouldRefund: false });
  }

  onConfirm(): void {
    if (this.isProcessing) return;
    this.isProcessing = true;
    // Close immediately with the result - the parent will handle the actual processing
    this.dialogRef.close({ confirmed: true, shouldRefund: this.shouldRefund });
  }
}
